const htmlErrorMessageHash = {
  403: "<span>Insufficient privileges</span>",
  404: "<span>User not found</span>",
};

export default {
  getApiHtmlErrorMessage(err, priorityHtmlErrorMessageHash) {
    let htmlErrorMessage = "<span>Service unavailable</span>";

    if (
      err.response
      && err.response.status
    ) {
      const httpStatusCode = err.response.status;
      if (
        priorityHtmlErrorMessageHash
        && priorityHtmlErrorMessageHash[httpStatusCode]
      ) {
        htmlErrorMessage = priorityHtmlErrorMessageHash[httpStatusCode];
      } else if (htmlErrorMessageHash[httpStatusCode]) {
        htmlErrorMessage = htmlErrorMessageHash[httpStatusCode];
      } else {
        htmlErrorMessage = `<span>Service returned status code <b>${httpStatusCode}</b></span>`;
      }
    }

    return htmlErrorMessage;
  },
};
